/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import de from './de/translations.json.js';
import en from './en/translations.json.js';
import es from './es/translations.json.js';
import fr from './fr/translations.json.js';
import it from './it/translations.json.js';
import ja from './ja/translations.json.js';
import ko from './ko/translations.json.js';
import ptBr from './pt-br/translations.json.js';
import zhCn from './zh-cn/translations.json.js';
import zhTw from './zh-tw/translations.json.js';

var locales = {
  de: {
    translations: de
  },
  en: {
    translations: en
  },
  es: {
    translations: es
  },
  fr: {
    translations: fr
  },
  it: {
    translations: it
  },
  ja: {
    translations: ja
  },
  ko: {
    translations: ko
  },
  'pt-BR': {
    translations: ptBr
  },
  'zh-CN': {
    translations: zhCn
  },
  'zh-TW': {
    translations: zhTw
  }
};

export { locales as default };
